import axios from 'axios';

// @TODO Do this in a less ugly, intrusive way. We don't want to be using
//       manual overrides right in Payment SDK like this. Maybe allow
//       overriding the request method via a localStorage flag.
const isCdn = (apiURL: string): boolean =>
  apiURL.includes('unpkg.com') ||
  apiURL.includes('cdn.jsdelivr.net') ||
  apiURL.includes('payment-element.cloudbeds.com') ||
  apiURL.includes('payment-element.cloudbeds-stage.com');

export const queryPaymentMethodHash = async (
  propertyId: number,
  bearerToken: string,
  payload: object,
  apiURL?: string,
) => {
  if (!apiURL) return { error: 'Unknown network error.' };
  try {
    const apiEndpoint = '/payments/payment-methods/v1.0/hash';

    const { data: response } = isCdn(apiURL)
      ? await axios.get(apiEndpoint, { baseURL: apiURL })
      : await axios.post(apiEndpoint, payload, {
          baseURL: apiURL,
          headers: {
            'X-Property-Id': propertyId,
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearerToken}`,
          },
        });

    return response.status
      ? { ...response }
      : { error: response.error || response.statusMessage || 'Unknown error.' };
  } catch (err) {
    return { error: err.message || 'Unknown network error.' };
  }
};
